import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import './index.css'
import UtilityNav from '../../../_components/common/UtilityNav';
import TableNew from '../../../_components/common/Table';
import ModalComponent from '../../../_components/common/Modal';
import { Input } from 'reactstrap';
import { paUserPermissions, teamName } from './formData';
import { orgAdminAction } from '../../../_actions';
import AccessData from '../../../_components/common/AccessData';
import tableSort from '../../../_components/common/Sort';


class ModulePermissions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            allowAccess: false,
            denyAccess: false,
            modulePermissionsList: '',
            checkBoxData: [],
            updateModalState: false,
            updateMessage: null,
            sortType: false,
            orgId: null,
            paUserId: 'null',
            paUserName: null,
            buttonData: [],
            navData: [],
        }
    }

    componentDidMount() {
        this.setState({
            orgId: +this.props.match.params.id
        })

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        this.props.dispatch(orgAdminAction.getOrgUsersHandler(+this.props.match.params.id, () => {
            this.props.dispatch(orgAdminAction.getMasterModuleListhandler(() => {
                let pathName = this.props.location.pathname.split('/');
                if (pathName[pathName.length - 1] === 'ModulePermissions' && this.props.getOrgUsersResponse.length > 0) {
                    const fd = {
                        "pa_user_email":this.props.getOrgUsersResponse.length>0? this.props.getOrgUsersResponse[0].pa_user__email:'',
                        "organisation_id": +this.props.match.params.id
                    }
                    this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => { }))
                    const queryParams = [];
                    queryParams.push(encodeURIComponent('user') + '=' + encodeURIComponent(this.props.getOrgUsersResponse[0].id))
                    const queryString = queryParams.join('&');
                    this.props.history.replace({
                        search: '?' + queryString
                    });
                    this.setState({
                        paUserName: this.props.getOrgUsersResponse[0].pa_user__email,
                    })
                    // this.props.history.replace(`/organisation/${this.props.match.params.id}/org-admin/ModulePermissions/${this.props.getOrgUsersResponse[0].id}`)
                }

                pathName[pathName.length - 1] !== 'ModulePermissions' &&
                    this.props.getOrgUsersResponse.map(
                        (data, i) => {

                            if (+pathName[pathName.length - 1] === data.id) {
                                const queryParams = [];
                                queryParams.push(encodeURIComponent('user') + '=' + encodeURIComponent(+pathName[pathName.length - 1]))
                                const queryString = queryParams.join('&');

                                // this.props.history.replace({
                                //     search: '?' + queryString
                                // });

                                // this.props.history.replace(`/organisation/${this.props.match.params.id}/org-admin/PaUsersPermissions/${+pathName[pathName.length - 1]}`)
                                this.setState({
                                    paUserName: data.pa_user__email,
                                    paUserId: pathName[pathName.length - 1]
                                }, () => {
                                    const fd = {
                                        "pa_user_email": data.pa_user__email,
                                        "organisation_id": +this.props.match.params.id
                                    }
                                    this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => { }))
                                })

                            }
                        }
                    )
            }))


        }))


        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Allow Access',
                    toggler: this.toggleAllowAccessModal.bind(this),
                    togglerModal: this.state.allowAccess,
                    disabled: 'disabled',
                    title: 'Allow Access',
                    icon: 'fa fa-plus',
                },
                {
                    id: 2,
                    name: 'Deny Access',
                    toggler: this.toggleDenyAccessModal.bind(this),
                    togglerModal: this.state.denyAccess,
                    disabled: 'disabled',
                    title: 'Deny Access',
                    icon: 'fa fa-minus',
                }
            ]
        })
    }
    
    componentDidUpdate(prevProps, prevState) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if (prevProps.getModulePermissionsListResponse !== this.props.getModulePermissionsListResponse) {
            let formatedData = [];
            (this.props.getModulePermissionsListResponse !== '' && this.props.getMasterModuleListResponse !== '' && this.props.getMasterModuleListResponse !== undefined) &&
                this.props.getMasterModuleListResponse.map(
                    (data, i) => {
                        let count = 0;
                        for (let i = 0; i < this.props.getModulePermissionsListResponse.length; i++) {
                            if (this.props.getModulePermissionsListResponse[i].module_list_id === data.id) {
                                count = count + 1;
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...data,
                                'rowCheck': true,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...data,
                                'rowCheck': true,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    }
                )
            if (this.props.getModulePermissionsListResponse !== '' && this.props.getMasterModuleListResponse !== '') {
                this.setState({
                    modulePermissionsList: formatedData
                })
            }

        }

    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }


    toggleAllowAccessModal(showModal) {
        this.setState({
            allowAccess: showModal
        })
    }

    toggleDenyAccessModal(showModal) {
        this.setState({
            denyAccess: showModal
        })
    }

    onChangeTeam = (ev) => {

        const paUserName = this.props.getOrgUsersResponse.filter(
            (data, i) => {
                if (data.id === +ev.target.value) {
                    return data
                }
            }
        )[0].pa_user__email;
        this.setState({
            paUserId: ev.target.value,
            paUserName: paUserName
        })
        this.props.history.replace(`/organisation/${this.props.match.params.id}/org-admin/ModulePermissions`);
        const queryParams = [];
        queryParams.push(encodeURIComponent('user') + '=' + encodeURIComponent(ev.target.value))
        const queryString = queryParams.join('&');
        this.props.history.push({
            search: '?' + queryString
        });

        const fd = {
            "pa_user_email": paUserName,
            "organisation_id": +this.state.orgId
        }
        this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => { }))

    }

    getSelectedData = (data) => {

        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getAccessModalData = (checkBoxData) => {
        const headings = [{
            'name': 'Module Name',
            'textCenter': false
        }, {
            'name': 'Access',
            'textCenter': true

        }]
        const keyNames = [{
            'name': 'module_name'
        }]
        return AccessData(checkBoxData, headings, keyNames)

    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.modulePermissionsList
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ modulePermissionsList: arrayCopy });
    }

    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {
            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {
                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    toggleEntireModulePermissionsModal(showModal) {
        this.setState({
            allowAccess: showModal,
            denyAccess: showModal,
            toggleAnalysis: showModal,
        })
    }

    actionSelectedAccess = (type) => {
        if (type === 'Add' || type === 'Remove') {
            const moduleId = [];
            const { checkBoxData } = this.state;
            for (let i = 0; i < checkBoxData.length; i++) {
                if (type === 'Add') {
                    if (checkBoxData[i].access === ' fa fa-times text-danger') {
                        moduleId.push(checkBoxData[i].id)
                    }
                }
                if (type === 'Remove') {
                    if (checkBoxData[i].access === ' fa fa-check text-success') {
                        moduleId.push(checkBoxData[i].id)
                    }
                }
            }
            const fd = {
                'module_id_list': moduleId,
                'pa_user_email': this.state.paUserName,
                'organisation_id': this.state.orgId
            }
            this.props.dispatch(orgAdminAction.changeAccessModuleHandler(fd, type, (data) => {
                const fd1 = {
                    "pa_user_email": this.state.paUserName,
                    "organisation_id": +this.state.orgId,
                    // "user_id": ev.target.value
                }

                this.setState({
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message[0].message}.</p>
                    </div>`,
                        heading: 'MODULE PERMISSIONS',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
                this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd1, () => { }))
            }))
        }
        this.setState({
            allowAccess: false,
            denyAccess: false
        })
    }

    getReformatedTableData = (getModulePermissionsListResponse, getMasterModuleListResponse) => {

        let formatedData = []
        getMasterModuleListResponse.map(
            (data, i) => {
                let count = 0;
                for (let i = 0; i < getModulePermissionsListResponse.length; i++) {
                    if (getModulePermissionsListResponse[i].module_list_id === data.id) {
                        count = count + 1;

                    }
                }
                if (count > 0) {
                    formatedData.push({
                        ...data,
                        'rowCheck': true,
                        'access': ' fa fa-check text-success',
                    })
                }
                if (count === 0) {
                    formatedData.push({
                        ...data,
                        'rowCheck': true,
                        'access': ' fa fa-times text-danger',
                    })
                }
            }
        )
        return formatedData
    }

    render() {
        const { getOrgUsersResponse, getOrgUsersLoading, getMasterModuleListResponse, getModulePermissionsListResponse } = this.props;
        const tables = {
            Team: [{
                name: 'Modules',
                key: 'module_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            },
            {
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
                buttonDisabled: 'buttonDisabled',
                link: ''

            },

            ]
        }
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MODULE PERMISSIONS</h5>
                        <div className="d-flex flex-row justify-content-center">
                            <span className="col- my-1 mb-0" > Choose PA User: &nbsp;
                                	{/* {
                                    getOrgUsersLoading &&
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                } */}
                            </span>

                            <Input
                                value={this.state.paUserId}
                                type="select" name="field"
                                bsSize="sm" className="col-2 border-1"
                                onChange={this.onChangeTeam}
                            >
                                {
                                    getOrgUsersResponse !== '' &&
                                    getOrgUsersResponse.map(
                                        (data, i) => {
                                            return <option className="" value={data.id} key={i}>{data.pa_user__email}</option>
                                        }
                                    )
                                }

                            </Input>
                            {
                                (getOrgUsersResponse !== '' && getOrgUsersResponse.length === 0) &&
                                <span className=" text-danger font-weight-bold my-1 mb-0">&nbsp;*Please Add PA user</span>
                            }
                        </div>
                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            (getModulePermissionsListResponse !== '' && getOrgUsersResponse !== '' && getMasterModuleListResponse !== ''&&getOrgUsersResponse.length>0) &&
                            <TableNew
                                data={this.state.modulePermissionsList === '' ? this.getReformatedTableData(getModulePermissionsListResponse, getMasterModuleListResponse) : this.state.modulePermissionsList}
                                columns={tables.Team}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {/* {
                            (getModulePermissionsListResponse === '' || getOrgUsersResponse === '' || getMasterModuleListResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        } */}

                        {
                            this.state.allowAccess &&
                            <ModalComponent
                                showModal={this.state.allowAccess}
                                heading="Allow Access"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireModulePermissionsModal.bind(this)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}

                            />
                        }

                        {
                            this.state.denyAccess &&
                            <ModalComponent
                                showModal={this.state.denyAccess}
                                heading="Deny Access"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedDenyAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireModulePermissionsModal.bind(this)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>

                </ div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { getOrgUsersLoading } = state.getOrgUsers;
    const getOrgUsersError = state.getOrgUsers.error;
    const getOrgUsersResponse = (!getOrgUsersLoading && !getOrgUsersError) ? state.getOrgUsers.data.data.organisation_PA_users : '';

    const { getMasterModuleListLoading } = state.getMasterModuleListReducer;
    const getMasterModuleListError = state.getMasterModuleListReducer.error;
    const getMasterModuleListResponse = (!getMasterModuleListLoading && !getMasterModuleListError) ? state.getMasterModuleListReducer.data.data.modules : '';

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getOrgUsersLoading,
        getOrgUsersResponse,
        getMasterModuleListResponse,
        getModulePermissionsListResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(ModulePermissions);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/ModulePermissions.js